// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-02T21:24:54.805Z
// Property: Rocklin Gold (ID: 6767906449166904)
// Collections: 26 amenities, 2 floorplans (live), 36 photos, 37 POIs, 1 reviews, 4 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166904",
  "property_external_id": "495827",
  "property_zillow_url": "https://www.zillow.com/homedetails/2651-Sunset-Blvd-Rocklin-CA-95677/188072714_zpid/",
  "property_apartments_url": "https://www.apartments.com/rocklin-gold-rocklin-ca/6m9262s/",
  "property_google_business_url": "https://www.google.com/maps/place/Rocklin+Gold+Apartments/data=!4m2!3m1!1s0x0:0xb5e58dbee95c95ad?sa=X&ved=2ahUKEwjLvrftlbySAxXQZ0EAHYCPNuAQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495827 p0505495",
  "property_status": null,
  "property_slug": "rocklin-gold",
  "property_name": "Rocklin Gold",
  "property_website_url": "www.rocklincaliforniaapartments.com",
  "property_domain": "https://www.rocklincaliforniaapartments.com/",
  "property_address": "2651 Sunset Boulevard",
  "property_full_address": "2651 Sunset Boulevard, Rocklin, CA, 95677",
  "property_address_1": "2651 Sunset Boulevard",
  "property_address_2": null,
  "property_address_city": "Rocklin",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95677",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "Outer Roseville/Rocklin",
  "property_address_latitude": "38.7912",
  "property_address_longitude": "-121.2579",
  "property_email": "rocklingold@ctlmanagement.com",
  "property_phone": "(279) 238-1408",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Rocklin Gold in Rocklin, CA, your ideal lifestyle awaits! Choose from spacious one and two-bedroom floor plans, dive into the shimmering swimming pool, or stay active in our modern fitness center. With reserved parking and a welcoming pet policy, your perfect home is just a click away. Schedule a tour today!",
  "property_long_description": "### Discover Your Dream Home at Rocklin Gold\n\nWelcome to Rocklin Gold, where luxury meets convenience in the heart of beautiful Rocklin, CA. Our stunning apartment community offers a variety of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom options, perfect for individuals, couples, and families alike. \n\nAt Rocklin Gold, we prioritize your comfort and lifestyle. Dive into relaxation at our inviting swimming pool, work up a sweat in our modern fitness center, or take advantage of our convenient reserved parking. For pet lovers, our community embraces your furry friends with a welcoming pet policy, ensuring that every member of your family feels at home. \n\nLocated in a vibrant neighborhood, you’ll enjoy easy access to nearby shopping, dining, and recreational activities. Explore local parks or take a short drive to the beautiful Sierra Nevada foothills for outdoor adventures. \n\nDon’t miss out on the opportunity to experience everything Rocklin Gold has to offer. Whether you're looking for a cozy retreat or a spacious family home, find your ideal apartment today. Browse our availability or schedule a tour to visit our community and discover why Rocklin Gold is the perfect place to call home. Your new lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019db18c-ccd4-718d-abdf-052734204a56.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a cabana.",
    "public_id": "019db18c-ccd4-718d-abdf-052734204a56",
    "storage_key": "property/6767906449166904/019db18c-ccd4-718d-abdf-052734204a56.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "121",
  "property_year_built": "1990",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.69421487603306",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://rocklincaliforniaapartments.securecafe.com/onlineleasing/rocklin-gold-0/floorplans.aspx",
  "property_resident_portal_url": "https://rocklincaliforniaapartments.securecafe.com/residentservices/rocklin-gold-0/userlogin.aspx",
  "property_apply_now_url": "https://rocklincaliforniaapartments.securecafe.com/onlineleasing/rocklin-gold-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d7405-c25f-71fa-a4ff-04a1fb3918e3.webp",
  "property_primary_logo_media": {
    "alt_text": "Rocklin Gold Apartments logo",
    "public_id": "019d7405-c25f-71fa-a4ff-04a1fb3918e3",
    "storage_key": "property/6767906449166904/019d7405-c25f-71fa-a4ff-04a1fb3918e3.webp",
    "width": 584,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d7405-c276-7416-8f30-39f44f145f2a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Rocklin Gold Apartments logo",
    "public_id": "019d7405-c276-7416-8f30-39f44f145f2a",
    "storage_key": "property/6767906449166904/019d7405-c276-7416-8f30-39f44f145f2a.webp",
    "width": 598,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019de0b2-7b9b-701e-af15-7a23533c93d2.webp",
  "property_mono_white_logo_media": {
    "alt_text": "No image available",
    "public_id": "019de0b2-7b9b-701e-af15-7a23533c93d2",
    "storage_key": "property/6767906449166904/019de0b2-7b9b-701e-af15-7a23533c93d2.webp",
    "width": 584,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019de0b2-6f49-758f-9ea9-771e16b6aa01.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangular bar overlaying a white background.",
    "public_id": "019de0b2-6f49-758f-9ea9-771e16b6aa01",
    "storage_key": "property/6767906449166904/019de0b2-6f49-758f-9ea9-771e16b6aa01.webp",
    "width": 584,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "784 - 1074",
  "property_sqft_min": "784",
  "property_sqft_max": "1074",
  "property_price_range": "1880 - 2520",
  "property_price_min": "1880",
  "property_price_max": "2520",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/RocklinGoldApartments/mentions/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJbbr3vV4fm4ARrZVc6b6N5bU",
  "property_youtube_url": "https://www.youtube.com/watch?v=apJILXGZnYg",
  "property_yelp_url": "https://www.yelp.com/biz/rocklin-gold-apartments-rocklin?start=5",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rocklin Gold",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Rocklin Gold, where modern living meets comfort in the heart of Rocklin, CA. Choose from one or two-bedroom floor plans and enjoy resort-style amenities, including a sparkling swimming pool, a fully-equipped fitness center, and reserved parking. Your perfect home awaits—come see why we shine!",
  "property_home_floorplans_blurb": "Welcome to Rocklin Gold, where modern living meets comfort in the heart of Rocklin, CA. Our thoughtfully designed floor plans cater to your unique lifestyle, offering spacious layouts and contemporary finishes. Browse our available apartment homes today and uncover the ideal space that truly feels like home.",
  "property_home_gallery_blurb": "At Rocklin Gold in sunny Rocklin, CA, find your perfect haven with one- and two-bedroom floor plans. Enjoy a resort-style swimming pool, a state-of-the-art fitness center, and convenient reserved parking. Embrace a lifestyle tailored for both relaxation and activity—picture yourself living here! Your new home awaits.",
  "property_home_neighborhood_blurb": "At Rocklin Gold, you’ll find spacious one and two-bedroom floor plans nestled in a vibrant community. Nestled close to parks, educational hubs like Sierra College, and attractions such as the Maidu Museum and Vernon Street Town Square, living here means enjoying a perfect blend of comfort and convenience in Rocklin, CA.",
  "property_home_reviews_blurb": "Welcome to Rocklin Gold, where residents rave about the \"welcoming atmosphere and exceptional service.\" Nestled in the heart of Rocklin, CA, our vibrant community offers more than just apartments—it's a lifestyle. Curious about life here? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in Rocklin, CA, Rocklin Gold offers seamless access to vibrant local attractions and essential services. Enjoy nearby parks like Maidu Regional Park and Harry Crabb Park for outdoor adventures, or explore cultural gems such as the Sierra College Natural History Museum. Elevate your lifestyle amidst engaging experiences waiting right outside your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Rocklin Gold, where comfort meets convenience in the heart of Rocklin, CA. Our community boasts inviting one- and two-bedroom floor plans, a sparkling swimming pool, a state-of-the-art fitness center, and reserved parking. Plus, we’re pet-friendly—your furry friends are welcome too! Experience the lifestyle you deserve.",
  "property_applynow_blurb": "At Rocklin Gold in sunny Rocklin, CA, your dream apartment awaits! Choose from spacious one or two-bedroom floor plans, unwind at the sparkling swimming pool, or break a sweat in our fitness center. With reserved parking and a friendly pet policy, it's time to find your new home—lease online today!",
  "property_contactus_blurb": "At Rocklin Gold in beautiful Rocklin, CA, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Each home invites you to experience modern living at its finest. Have questions? Contact our leasing team today and find your ideal apartment!",
  "property_faqs_blurb": "At Rocklin Gold in sunny Rocklin, CA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Curious about amenities, leasing, or community events? Our FAQs page is your go-to resource for all the answers you need to make the most of your home.",
  "property_floorplans_blurb": "At Rocklin Gold in beautiful Rocklin, CA, our thoughtfully designed floor plans cater to your lifestyle. Whether you're seeking a cozy one-bedroom retreat or a spacious two-bedroom oasis, each layout promises comfort and style. Browse our available apartment homes and uncover the perfect space that feels just like home.",
  "property_gallery_blurb": "At Rocklin Gold in beautiful Rocklin, CA, envision a vibrant lifestyle with our inviting one- and two-bedroom apartments. Dive into relaxation by our sparkling swimming pool, stay fit in our well-equipped fitness center, and enjoy the convenience of reserved parking—all while having your furry friend by your side. Picture yourself living here!",
  "property_interactivemap_blurb": "At Rocklin Gold in vibrant Rocklin, CA, choose from spacious one or two-bedroom floor plans designed for comfort. Dive into our refreshing swimming pool, stay active in the fitness center, and enjoy the convenience of reserved parking. Ready to find your perfect home? Navigate our interactive community map today!",
  "property_pets_blurb": "At Rocklin Gold, we embrace your furry companions with open arms! Our pet-friendly community welcomes indoor adult cats and dogs under 25 lbs, so you can enjoy life in Rocklin, CA, together. Plus, small caged animals add to the fun—all in a vibrant, stylish environment designed for pet lovers.",
  "property_referafriend_blurb": "At Rocklin Gold in sunny Rocklin, CA, our vibrant community offers thoughtfully designed one and two-bedroom floor plans for every lifestyle. Enjoy the perks of great friends as neighbors—refer a friend today and elevate your living experience in a place where comfort and connection thrive.",
  "property_residentaccess_blurb": "Welcome to Rocklin Gold in beautiful Rocklin, CA! Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Need assistance? Access your resident portal to pay rent, schedule maintenance, and stay connected. Elevate your living experience today—everything you need is just a click away!",
  "property_reviews_blurb": "At Rocklin Gold in sunny Rocklin, CA, our residents rave about the vibrant community atmosphere, with one resident noting, \"The friendly neighbors and beautiful grounds make coming home a pleasure!\" See what our residents have to say about living at our community and experience the joy of Rocklin Gold for yourself!",
  "property_created_at": "1762785081910",
  "property_scheduletour_blurb": "At Rocklin Gold in sunny Rocklin, CA, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Experience comfort and modern living with inviting spaces and vibrant community vibes. Don’t just take our word for it—see what our residents have to say and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Rocklin Gold! Our inviting one and two-bedroom floor plans promise comfort and style in the heart of Rocklin, CA. Our team will connect with you soon to guide you through our vibrant community. Your new home adventure is just around the corner!",
  "property_virtualtours_blurb": "Experience the charm of Rocklin Gold, where modern living meets comfort in the heart of Rocklin, CA. With thoughtfully designed one and two-bedroom floor plans, our community offers more than just a home; it’s a lifestyle. Take a virtual tour today and envision your new sanctuary!",
  "property_copyright": "2025 All Rights Reserved. Rocklin Gold",
  "property_seo_title_home": "Rocklin Gold |  Apartments in Rocklin, CA",
  "property_seo_description_home": "Welcome to Rocklin Gold! Discover spacious one and two-bedroom apartments, a pool, fitness center, and pet-friendly living in Rocklin, CA!",
  "property_seo_title_floorplans": "Floor Plans | Rocklin, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal sanctuary at Rocklin Gold! Choose from spacious one or two-bedroom apartment floor plans in beautiful Rocklin, CA. Browse now!",
  "property_seo_title_amenities": "Amenities | Rocklin, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Rocklin Gold! Dive into our pool, stay fit at the gym, and enjoy spacious 1 & 2-bedroom apartments. Unwind today!",
  "property_seo_title_gallery": "Gallery | Apartments in Rocklin, CA",
  "property_seo_description_gallery": "Picture your new life at Rocklin Gold in CA! From stunning pools to spacious floor plans, see the lifestyle waiting for you in our photo gallery.",
  "property_seo_title_virtualtours": "Virtual Tours | Rocklin Gold Apartments",
  "property_seo_description_virtualtours": "Experience the beauty of Rocklin Gold! Take a virtual tour of our one and two-bedroom apartments, and envision your new lifestyle in Rocklin, CA.",
  "property_seo_title_interactivemap": "Interactive Map | Rocklin Gold Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at Rocklin Gold! Use our interactive map to explore spacious layouts, amenities, and pricing in beautiful Rocklin, CA.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rocklin, CA",
  "property_seo_description_neighborhood": "Uncover the charm around Rocklin Gold in Rocklin, CA. Dive into local favorites and explore hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Rocklin Gold",
  "property_seo_description_contact": "Connect with Rocklin Gold in CA! Choose from stylish one and two-bedroom floor plans. Have questions? Our leasing team is here to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Rocklin, CA",
  "property_seo_description_faqs": "Get the lowdown on Rocklin Gold in CA! Check our FAQs for insights on our one- and two-bedroom apartments, amenities, and pet policy. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rocklin, CA",
  "property_seo_description_reviews": "Live your best life at Rocklin Gold! Dive into community vibes, fitness options, and pet-friendly spaces. Check out our residents’ experiences today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Rocklin, CA",
  "property_seo_description_applynow": "Experience comfort at Rocklin Gold! Choose 1 or 2-bedroom apartments, enjoy our pool & fitness center. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Rocklin Gold",
  "property_seo_description_residentaccess": "Log in to Rocklin Gold's portal for easy rent payments, maintenance requests, and community updates—all from beautiful Rocklin, CA!",
  "property_seo_title_referafriend": "Refer A Friend | Rocklin Gold",
  "property_seo_description_referafriend": "Invite friends to experience the charm of Rocklin Gold! Great friends make great neighbors—spread the word and enjoy rewards for sharing your home!",
  "property_seo_title_scheduletour": "Schedule a Tour | Rocklin Gold",
  "property_seo_description_scheduletour": "Experience modern living at Rocklin Gold. Schedule a tour today to see your future home in Rocklin, CA, where comfort meets style and community thrives!",
  "property_seo_title_privacy": "Privacy Policy | Rocklin Gold",
  "property_seo_description_privacy": "At Rocklin Gold, your privacy matters. Discover how we protect your information while you enjoy exceptional living in Rocklin, CA.",
  "property_seo_title_accessibility": "Website Accessibility | Rocklin Gold",
  "property_seo_description_accessibility": "Join us at Rocklin Gold in CA, where inclusivity and accessibility foster connection and community for everyone. Feel at home with us!",
  "property_seo_title_sitemap": "Sitemap | Rocklin Gold",
  "property_seo_description_sitemap": "Navigate your way through Rocklin Gold's offerings! Check out our sitemap for easy access to amenities, floor plans, and community features in Rocklin, CA.",
  "property_seo_title_thankyou": "Thank You | Rocklin Gold",
  "property_seo_description_thankyou": "Thank you for reaching out to Rocklin Gold! Your inquiry is important to us, and we’ll connect soon to help you find your perfect home in sunny Rocklin, CA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Rocklin, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778875141384",
  "amenities": [
    {
      "id": "ec_ed4e41aedbdaa72ec7de7396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429327",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-3d0f-7480-83f1-290b41dd858b.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computer, printer, and exit door.",
        "public_id": "019d1c08-3d0f-7480-83f1-290b41dd858b",
        "storage_key": "property/6767906449166904/019d1c08-3d0f-7480-83f1-290b41dd858b.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Business Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2a5acdfbd44743c6920de48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429332",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-0c60-757d-adc4-0c50eae56019.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a yellow umbrella on a sunny day.",
        "public_id": "019eb039-0c60-757d-adc4-0c50eae56019",
        "storage_key": "property/6767906449166904/019eb039-0c60-757d-adc4-0c50eae56019.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A round swimming pool surrounded by trees and chairs at Rocklin Gold Apartments, California, 95677,A pool surrounded by a black fence and trees at Rocklin Gold Apartments, California, 95677",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73262e5ab5d71b4fa8c36c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429335",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-058c-7651-9829-f421e98b5001.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019eb039-058c-7651-9829-f421e98b5001",
        "storage_key": "property/6767906449166904/019eb039-058c-7651-9829-f421e98b5001.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "A hot tub sits in the middle of a patio surrounded by trees at Rocklin Gold Apartments, California, 95677",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c57f7bb77a0777b2620c003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429328",
      "title": "Car Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b450409ecb26dfd360f616f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "86392930",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1ede-8a22-76bf-89de-5a969501f029.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a stone fireplace, sofa, accent chairs, and a rustic coffee table.",
        "public_id": "019d1ede-8a22-76bf-89de-5a969501f029",
        "storage_key": "property/6767906449166904/019d1ede-8a22-76bf-89de-5a969501f029.webp",
        "width": 3072,
        "height": 2039
      },
      "amenity_image_alt_text": "Rocklin Gold clubhouse fireplace lounge,Rocklin Gold Clubhouse",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53cb8393061e33808b09dc84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80683420",
      "title": "Recreation Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58b8adb2a615c2072b7735e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80683419",
      "title": "Pool Table",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d20b8-9189-71bb-9445-b4b8d1dc218a.webp",
      "amenity_image_media": {
        "alt_text": "Billiard table in a game room with a TV screen and seating.",
        "public_id": "019d20b8-9189-71bb-9445-b4b8d1dc218a",
        "storage_key": "property/6767906449166904/019d20b8-9189-71bb-9445-b4b8d1dc218a.webp",
        "width": 1200,
        "height": 798
      },
      "amenity_image_alt_text": "Rocklin Gold Apartments Billiards Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b7536a6aa7bf3c89771b114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429325",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c12-67f3-70d5-8a09-6adfdbf0cd9f.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and weight machines.",
        "public_id": "019d1c12-67f3-70d5-8a09-6adfdbf0cd9f",
        "storage_key": "property/6767906449166904/019d1c12-67f3-70d5-8a09-6adfdbf0cd9f.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Fitness Center",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4630187ba28f5bad21b3f6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80683418",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1ede-6ada-7330-a2f1-685fb1973d76.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slide and monkey bars.",
        "public_id": "019d1ede-6ada-7330-a2f1-685fb1973d76",
        "storage_key": "property/6767906449166904/019d1ede-6ada-7330-a2f1-685fb1973d76.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Play Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ded5e870a4cec37125d3eb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "86392934",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-1566-77a9-bafb-31d4f4e662fb.webp",
      "amenity_image_media": {
        "alt_text": "Secure package lockers with the name \"Rocklin Gold Ap\" visible.",
        "public_id": "019eb039-1566-77a9-bafb-31d4f4e662fb",
        "storage_key": "property/6767906449166904/019eb039-1566-77a9-bafb-31d4f4e662fb.webp",
        "width": 1800,
        "height": 1202
      },
      "amenity_image_alt_text": "Gray package lockers at Rocklin Gold Apartments, California, 95677",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_316ebef1982b148e12e2a8b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "86392933",
      "title": "Free Movie Rental Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d14ba84793962cec24c271b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429330",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d29064444593c0785acba81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "86392935",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f21b8f46ea206092773310de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "82390243",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7f0b21d71bb8de42c3fa374",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "82390245",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed3f2305254d7efaaa3cbcc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "86392936",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40d84a92e468845429922484",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429341",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_909b4cac5dddb95832be007d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429338",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcb8c36775162cc684be6087",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429343",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-13d1-7145-a03b-156bb366ab04.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a fireplace, couch, and decorative accents.",
        "public_id": "019d1c08-13d1-7145-a03b-156bb366ab04",
        "storage_key": "property/6767906449166904/019d1c08-13d1-7145-a03b-156bb366ab04.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold model living room and fireplace",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f14698ac93aa4e33298ee9e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429333",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7855f5fca9ebd7c9c7b6ac00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429342",
      "title": "Oversized Walk-In Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-24a7-761b-9565-4d70945524c3.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a closet and a washer/dryer area",
        "public_id": "019d1c08-24a7-761b-9565-4d70945524c3",
        "storage_key": "property/6767906449166904/019d1c08-24a7-761b-9565-4d70945524c3.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Model Master Bedroom & Walk In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5212c3e68ac25b82d777573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429337",
      "title": "Ceiling Fan In Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-1001-77f7-b1d7-bb3e73cb790f.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and kitchen with white appliances and cabinets.",
        "public_id": "019d1c08-1001-77f7-b1d7-bb3e73cb790f",
        "storage_key": "property/6767906449166904/019d1c08-1001-77f7-b1d7-bb3e73cb790f.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Model Dining Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68ba3350f5b80d764d2c09a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429340",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-26f8-754c-9667-494d5784b2ba.webp",
      "amenity_image_media": {
        "alt_text": "Clean and modern bathroom with shelves and shower",
        "public_id": "019d1c08-26f8-754c-9667-494d5784b2ba",
        "storage_key": "property/6767906449166904/019d1c08-26f8-754c-9667-494d5784b2ba.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Model Bathroom Storage",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1923e7b73496ad2a0b56f851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429336",
      "title": "Built-In Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-1371-77fa-aa59-66bca2c039fb.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d1c08-1371-77fa-aa59-66bca2c039fb",
        "storage_key": "property/6767906449166904/019d1c08-1371-77fa-aa59-66bca2c039fb.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Rocklin Gold Model Kitchen Bar",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0640686f1b5d90e3c90ee88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429331",
      "title": "On Greenbelt",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddeb17bcacb63dd2f5519574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "yardi",
      "external_id": "80429339",
      "title": "Dual Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_2b9ae25f8f405a6ee6ad360a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-1004-76c5-91dd-bb667e9d8d8c.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d1c08-1004-76c5-91dd-bb667e9d8d8c",
        "storage_key": "property/6767906449166904/019d1c08-1004-76c5-91dd-bb667e9d8d8c.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "This kitchen features light wood cabinetry, a white stove, microwave, and refrigerator, complemented by speckled granite countertops and dark wood-look flooring.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelUpgradedKitchen01.jpg"
    },
    {
      "id": "ec_4f3e645464d4c8aa52ff1ded",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-1371-77fa-aa59-66bca2c039fb.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d1c08-1371-77fa-aa59-66bca2c039fb",
        "storage_key": "property/6767906449166904/019d1c08-1371-77fa-aa59-66bca2c039fb.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample cabinet space, a full suite of white appliances, and stylish granite countertops. Perfect for home chefs.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelKitchenBar.jpg"
    },
    {
      "id": "ec_5a55dd9500e8cdefb96a97d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-13e6-7616-bb02-fdb7788027a8.webp",
      "image_media": {
        "alt_text": "Kitchen counter with decor, living room with fireplace, dining area, and hallway leading to bedroom.",
        "public_id": "019d1c08-13e6-7616-bb02-fdb7788027a8",
        "storage_key": "property/6767906449166904/019d1c08-13e6-7616-bb02-fdb7788027a8.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Modern kitchen counter with decorative items, leading to a spacious living room with a fireplace and a cozy dining area. Hallway offers a glimpse into the private bedroom.",
      "link": "false",
      "alt_text": "Kitchen counter with decor, living room with fireplace, dining area, and hallway leading to bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelKitchenDiningRoom.jpg"
    },
    {
      "id": "ec_ac0b7ceab81ed9f81b7b01ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-1001-77f7-b1d7-bb3e73cb790f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white appliances and cabinets.",
        "public_id": "019d1c08-1001-77f7-b1d7-bb3e73cb790f",
        "storage_key": "property/6767906449166904/019d1c08-1001-77f7-b1d7-bb3e73cb790f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "A well-lit dining area adjacent to a functional kitchen featuring white appliances, ample cabinet space, and a breakfast bar.",
      "link": "false",
      "alt_text": "Dining area and kitchen with white appliances and cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelDiningRoom01.jpg"
    },
    {
      "id": "ec_c988d3245b38d36de4063bb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-13e4-7751-bafc-9936733be633.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
        "public_id": "019d1c08-13e4-7751-bafc-9936733be633",
        "storage_key": "property/6767906449166904/019d1c08-13e4-7751-bafc-9936733be633.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating, a modern coffee table, and a well-lit kitchen space.",
      "link": "false",
      "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelLivingRoomEntry.jpg"
    },
    {
      "id": "ec_3862320b75b8833bd97af6ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-13d1-7145-a03b-156bb366ab04.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, couch, and decorative accents.",
        "public_id": "019d1c08-13d1-7145-a03b-156bb366ab04",
        "storage_key": "property/6767906449166904/019d1c08-13d1-7145-a03b-156bb366ab04.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable seating, and elegant decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a fireplace, couch, and decorative accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelLivingRoom01.jpg"
    },
    {
      "id": "ec_4e9e33c83d41125157e417ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-0fb2-71d3-80d2-052a639a7c0a.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and accent chair.",
        "public_id": "019d1c08-0fb2-71d3-80d2-052a639a7c0a",
        "storage_key": "property/6767906449166904/019d1c08-0fb2-71d3-80d2-052a639a7c0a.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable sofa, elegant coffee table, and a stylish accent chair. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, sofa, coffee table, and accent chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelLivingRoomSideView.jpg"
    },
    {
      "id": "ec_8019ab066a440f40406e9836",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-0fa3-7758-9984-7f517618405c.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace and sofa.",
        "public_id": "019d1c08-0fa3-7758-9984-7f517618405c",
        "storage_key": "property/6767906449166904/019d1c08-0fa3-7758-9984-7f517618405c.webp",
        "width": 400,
        "height": 267
      },
      "title": "Apartment",
      "description": "Relax in this comfortable living room, featuring a charming fireplace and a plush sofa, perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Cozy living room with a fireplace and sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelLivingRoomFireplaceView.jpg"
    },
    {
      "id": "ec_ead8549d2824644c8b0be40e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-13dd-7039-92ea-3f4962d692ad.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a queen-size bed with a navy blue tufted headboard and a gray geometric comforter.",
        "public_id": "019d1c08-13dd-7039-92ea-3f4962d692ad",
        "storage_key": "property/6767906449166904/019d1c08-13dd-7039-92ea-3f4962d692ad.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "A stylish bedroom with a queen-size bed, navy blue tufted headboard, and plush carpeting. This room offers a cozy and elegant retreat.",
      "link": "false",
      "alt_text": "A bedroom featuring a queen-size bed with a navy blue tufted headboard and a gray geometric comforter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelMasterBedroom01.jpg"
    },
    {
      "id": "ec_133d16c75d17268392d54a68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-10ba-76c6-bcfc-5f2877801425.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a plush tufted headboard, decorative pillows, and abstract wall art.",
        "public_id": "019d1c08-10ba-76c6-bcfc-5f2877801425",
        "storage_key": "property/6767906449166904/019d1c08-10ba-76c6-bcfc-5f2877801425.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this stylish bedroom, featuring a luxurious tufted headboard and elegant decorative accents for a serene retreat.",
      "link": "false",
      "alt_text": "Modern bedroom with a plush tufted headboard, decorative pillows, and abstract wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelMasterBedroom02.jpg"
    },
    {
      "id": "ec_6fea31597cec15d4e7fe8610",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-24a7-761b-9565-4d70945524c3.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a washer/dryer area",
        "public_id": "019d1c08-24a7-761b-9565-4d70945524c3",
        "storage_key": "property/6767906449166904/019d1c08-24a7-761b-9565-4d70945524c3.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting bedroom, featuring a spacious walk-in closet and a convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "Bedroom with a closet and a washer/dryer area",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelMasterBedroomWalkInCloset.jpg"
    },
    {
      "id": "ec_1f38335f33593f62f3eef74a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-289c-751d-aa16-3e29795d5db2.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, navy blue accents, and a large mirror.",
        "public_id": "019d1c08-289c-751d-aa16-3e29795d5db2",
        "storage_key": "property/6767906449166904/019d1c08-289c-751d-aa16-3e29795d5db2.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms. This spacious room features a queen-size bed with plush bedding and tasteful decor.",
      "link": "false",
      "alt_text": "Stylish bedroom with a queen-size bed, navy blue accents, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelSecondBedroomPatio.jpg"
    },
    {
      "id": "ec_f2ee31c41142eacf0a684b82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-26f8-754c-9667-494d5784b2ba.webp",
      "image_media": {
        "alt_text": "Clean and modern bathroom with shelves and shower",
        "public_id": "019d1c08-26f8-754c-9667-494d5784b2ba",
        "storage_key": "property/6767906449166904/019d1c08-26f8-754c-9667-494d5784b2ba.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a walk-in shower, vanity, and ample storage space on built-in shelves.",
      "link": "false",
      "alt_text": "Clean and modern bathroom with shelves and shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelBathroomStorage.jpg"
    },
    {
      "id": "ec_4640f21973896050ec861c78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-2611-732d-b042-4016fa4b6330.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, and faucet, next to a toilet.",
        "public_id": "019d1c08-2611-732d-b042-4016fa4b6330",
        "storage_key": "property/6767906449166904/019d1c08-2611-732d-b042-4016fa4b6330.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a single vanity with granite countertops, a white sink, and a chrome faucet. The space includes a toilet, a decorative picture, and neatly folded towels.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, sink, and faucet, next to a toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelUpgradedBathroom.jpg"
    },
    {
      "id": "ec_cef7da63432a4e37a4a16873",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-28e5-7667-8cd7-3f5382a06da7.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019d1c08-28e5-7667-8cd7-3f5382a06da7",
        "storage_key": "property/6767906449166904/019d1c08-28e5-7667-8cd7-3f5382a06da7.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a spacious bathroom featuring a single vanity with ample counter space, a full bathtub with shower, and a separate toilet area.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ModelSecondBathroom.jpg"
    },
    {
      "id": "ec_0c5561b6255f7575373b76d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb038-e2f1-727a-b431-475e3a728d4e.webp",
      "image_media": {
        "alt_text": "Rocklin Gold Apartment Homes signage with landscaping and lamppost",
        "public_id": "019eb038-e2f1-727a-b431-475e3a728d4e",
        "storage_key": "property/6767906449166904/019eb038-e2f1-727a-b431-475e3a728d4e.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Welcome to Rocklin Gold Apartment Homes, featuring beautiful landscaping and a charming lamppost at the entrance.",
      "link": "false",
      "alt_text": "Rocklin Gold Apartment Homes signage with landscaping and lamppost",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_MonumentSign.jpg"
    },
    {
      "id": "ec_bd355ec5b068cafbaa7b4e43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb038-e5bd-7078-834d-d45e375e6845.webp",
      "image_media": {
        "alt_text": "Exterior view of a single-story building with a gray facade, surrounded by lush greenery and mature trees.",
        "public_id": "019eb038-e5bd-7078-834d-d45e375e6845",
        "storage_key": "property/6767906449166904/019eb038-e5bd-7078-834d-d45e375e6845.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Charming exterior of a residential building nestled amidst beautifully landscaped gardens, offering a serene and welcoming atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of a single-story building with a gray facade, surrounded by lush greenery and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_Clubhouse.jpg"
    },
    {
      "id": "ec_1acca567da0b9e07248f06df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb038-e67a-77fc-9e7f-803db30a60ef.webp",
      "image_media": {
        "alt_text": "Walking path through landscaped grounds to a building and pool.",
        "public_id": "019eb038-e67a-77fc-9e7f-803db30a60ef",
        "storage_key": "property/6767906449166904/019eb038-e67a-77fc-9e7f-803db30a60ef.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy the resort-style amenities and beautifully maintained grounds, including a sparkling swimming pool and lush landscaping.",
      "link": "false",
      "alt_text": "Walking path through landscaped grounds to a building and pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ClubhouseWalkway.jpg"
    },
    {
      "id": "ec_07b64202d42aeaf9d448e773",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb038-e443-73bd-83d4-f433fca16723.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and building exterior surrounded by trees.",
        "public_id": "019eb038-e443-73bd-83d4-f433fca16723",
        "storage_key": "property/6767906449166904/019eb038-e443-73bd-83d4-f433fca16723.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the community pool or relax by the building's serene exterior. Lush trees provide ample shade.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and building exterior surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ClubhousePoolGate.jpg"
    },
    {
      "id": "ec_66050de6ff1329505443660c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1ede-8a22-76bf-89de-5a969501f029.webp",
      "image_media": {
        "alt_text": "Living room with a stone fireplace, sofa, accent chairs, and a rustic coffee table.",
        "public_id": "019d1ede-8a22-76bf-89de-5a969501f029",
        "storage_key": "property/6767906449166904/019d1ede-8a22-76bf-89de-5a969501f029.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a large stone fireplace, comfortable seating, and a rustic coffee table, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with a stone fireplace, sofa, accent chairs, and a rustic coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_ClubhouseFireplaceLounge.jpg"
    },
    {
      "id": "ec_c06dcae3c0725318c5e1e664",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-3cf5-7289-a4bb-65c3c85c8ef7.webp",
      "image_media": {
        "alt_text": "Spacious common area with a fireplace, seating area, and workspace.",
        "public_id": "019d1c08-3cf5-7289-a4bb-65c3c85c8ef7",
        "storage_key": "property/6767906449166904/019d1c08-3cf5-7289-a4bb-65c3c85c8ef7.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy our comfortable and inviting common area, perfect for relaxing or getting some work done. Featuring a cozy fireplace and ample seating.",
      "link": "false",
      "alt_text": "Spacious common area with a fireplace, seating area, and workspace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_Clubhouse01.jpg"
    },
    {
      "id": "ec_9a42b978f5bced80ef257670",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-38a7-72ce-9009-d67af0db628c.webp",
      "image_media": {
        "alt_text": "Community game room with pool table and board games.",
        "public_id": "019d1c08-38a7-72ce-9009-d67af0db628c",
        "storage_key": "property/6767906449166904/019d1c08-38a7-72ce-9009-d67af0db628c.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy some friendly competition in our community game room, featuring a billiards table and various board games for residents to enjoy.",
      "link": "false",
      "alt_text": "Community game room with pool table and board games.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_RecRoomPoolTable.jpg"
    },
    {
      "id": "ec_d8b9838b0bc5f51bd0fb039d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c08-3d0f-7480-83f1-290b41dd858b.webp",
      "image_media": {
        "alt_text": "Business center with computer, printer, and exit door.",
        "public_id": "019d1c08-3d0f-7480-83f1-290b41dd858b",
        "storage_key": "property/6767906449166904/019d1c08-3d0f-7480-83f1-290b41dd858b.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay connected and productive in our resident business center, featuring computers and printing services.",
      "link": "false",
      "alt_text": "Business center with computer, printer, and exit door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_BusinessCenter01.jpg"
    },
    {
      "id": "ec_75576b4a96ae026e586b3f66",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1c12-67f3-70d5-8a09-6adfdbf0cd9f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and weight machines.",
        "public_id": "019d1c12-67f3-70d5-8a09-6adfdbf0cd9f",
        "storage_key": "property/6767906449166904/019d1c12-67f3-70d5-8a09-6adfdbf0cd9f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio machines and weight training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical, stationary bike, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_FitnessCenter01.jpg"
    },
    {
      "id": "ec_673f0410c432381bf1847e07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-058c-7651-9829-f421e98b5001.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019eb039-058c-7651-9829-f421e98b5001",
        "storage_key": "property/6767906449166904/019eb039-058c-7651-9829-f421e98b5001.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and soothing hot tub, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_SwimmingPoolSpa.jpg"
    },
    {
      "id": "ec_2deabef828d49758df792bc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-0ce1-726a-867b-74bd5046a31a.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
        "public_id": "019eb039-0ce1-726a-867b-74bd5046a31a",
        "storage_key": "property/6767906449166904/019eb039-0ce1-726a-867b-74bd5046a31a.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, the perfect place to relax and soak up the sun. Lounge chairs and shaded areas are available for your comfort.",
      "link": "false",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_SwimmingPool.jpg"
    },
    {
      "id": "ec_551fa921e41d0142791daa0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-0c60-757d-adc4-0c50eae56019.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a yellow umbrella on a sunny day.",
        "public_id": "019eb039-0c60-757d-adc4-0c50eae56019",
        "storage_key": "property/6767906449166904/019eb039-0c60-757d-adc4-0c50eae56019.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and ample space for relaxation. Perfect for soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a yellow umbrella on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_SwimmingPoolClubhouse.jpg"
    },
    {
      "id": "ec_0f5bf9f7547e6f00096ec931",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-0fe1-7329-98fa-8d92aafd9da2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019eb039-0fe1-7329-98fa-8d92aafd9da2",
        "storage_key": "property/6767906449166904/019eb039-0fe1-7329-98fa-8d92aafd9da2.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_SwimmingPoolLounges.jpg"
    },
    {
      "id": "ec_7ef731263fb84ed70f2b4613",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d1ede-6ada-7330-a2f1-685fb1973d76.webp",
      "image_media": {
        "alt_text": "Playground with slide and monkey bars.",
        "public_id": "019d1ede-6ada-7330-a2f1-685fb1973d76",
        "storage_key": "property/6767906449166904/019d1ede-6ada-7330-a2f1-685fb1973d76.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a slide and monkey bars for children's entertainment.",
      "link": "false",
      "alt_text": "Playground with slide and monkey bars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_PlayArea.jpg"
    },
    {
      "id": "ec_a1a1e3841906080215794010",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-1566-77a9-bafb-31d4f4e662fb.webp",
      "image_media": {
        "alt_text": "Secure package lockers with the name \"Rocklin Gold Ap\" visible.",
        "public_id": "019eb039-1566-77a9-bafb-31d4f4e662fb",
        "storage_key": "property/6767906449166904/019eb039-1566-77a9-bafb-31d4f4e662fb.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Modern, secure package lockers available for resident convenience, labeled \"Rocklin Gold Ap\".",
      "link": "false",
      "alt_text": "Secure package lockers with the name \"Rocklin Gold Ap\" visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_PackageLockers.jpg"
    },
    {
      "id": "ec_515a68b742f1aa529faa0624",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-2319-706c-bf78-1eceb73ee460.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with grey siding, balconies, and outdoor staircases, behind a black metal fence and manicured hedge.",
        "public_id": "019eb039-2319-706c-bf78-1eceb73ee460",
        "storage_key": "property/6767906449166904/019eb039-2319-706c-bf78-1eceb73ee460.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with grey siding, balconies, and outdoor staircases, behind a black metal fence and manicured hedge. Enjoy the community amenities and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with grey siding, balconies, and outdoor staircases, behind a black metal fence and manicured hedge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_GatedCommunityExteriors.jpg"
    },
    {
      "id": "ec_a0e47f6c52d48d661661cc74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-2e24-744d-9ef0-293206831359.webp",
      "image_media": {
        "alt_text": "Pathway lined with landscaping and trees between apartment buildings",
        "public_id": "019eb039-2e24-744d-9ef0-293206831359",
        "storage_key": "property/6767906449166904/019eb039-2e24-744d-9ef0-293206831359.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Enjoy a stroll along this charming pathway, surrounded by lush greenery and mature trees, connecting you to your new home.",
      "link": "false",
      "alt_text": "Pathway lined with landscaping and trees between apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_BuildingExteriors.jpg"
    },
    {
      "id": "ec_7b71819d5912b5f4425fbdc3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-2f99-7065-9609-6440ce81f117.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees.",
        "public_id": "019eb039-2f99-7065-9609-6440ce81f117",
        "storage_key": "property/6767906449166904/019eb039-2f99-7065-9609-6440ce81f117.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with lush greenery and well-kept exteriors.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_BuildingExteriorPatiosDecks.jpg"
    },
    {
      "id": "ec_d1c7850c30de5756db4cba6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-2fea-72cc-a932-832281666845.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with landscaping and balcony.",
        "public_id": "019eb039-2fea-72cc-a932-832281666845",
        "storage_key": "property/6767906449166904/019eb039-2fea-72cc-a932-832281666845.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds surround this apartment building, featuring a private balcony with an umbrella and scenic views.",
      "link": "false",
      "alt_text": "Exterior of apartment building with landscaping and balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_BuildingExteriorLandscaping.jpg"
    },
    {
      "id": "ec_2584c25795384695c9fe4a79",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eb039-34ad-710c-a93e-cdcc99db5879.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with green trees and manicured lawns.",
        "public_id": "019eb039-34ad-710c-a93e-cdcc99db5879",
        "storage_key": "property/6767906449166904/019eb039-34ad-710c-a93e-cdcc99db5879.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex featuring lush greenery, mature trees, and well-kept exteriors, creating a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with green trees and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_Rocklin_CA_GreenSpace.jpg"
    },
    {
      "id": "ec_9abc235a61b2e283962a5790",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019eba71-9aa5-7422-9c01-44b8972c547d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stairs and manicured hedges.",
        "public_id": "019eba71-9aa5-7422-9c01-44b8972c547d",
        "storage_key": "property/6767906449166904/019eba71-9aa5-7422-9c01-44b8972c547d.webp",
        "width": 1800,
        "height": 1202
      },
      "title": "Community",
      "description": "Charming apartment buildings with a pathway lined by lush hedges and trees, offering a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stairs and manicured hedges.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RocklinGold_RocklinCA_BuildingExteriorsEntryWays.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_859e5960-c091-4c3b-a526-7d6bd91aa0de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-441b-7079-914d-100c2d7237ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-441b-7079-914d-100c2d7237ee",
        "storage_key": "property/6767906449166904/019d08af-441b-7079-914d-100c2d7237ee.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8594-76dc-85a5-91465483d7f8",
        "storage_key": "property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_16c35b0f-df3f-4beb-a65d-7fc211d410c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-d826-777f-9e37-985ba6983dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-d826-777f-9e37-985ba6983dc2",
        "storage_key": "property/6767906449166904/019d08af-d826-777f-9e37-985ba6983dc2.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8594-76dc-85a5-91465483d7f8",
        "storage_key": "property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f85ac728-c5e5-49a8-9d30-75978dae3741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-d885-70ac-9786-ea8cd54bcc97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-d885-70ac-9786-ea8cd54bcc97",
        "storage_key": "property/6767906449166904/019d08af-d885-70ac-9786-ea8cd54bcc97.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8594-76dc-85a5-91465483d7f8",
        "storage_key": "property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f60fdbb7-537a-49ae-801e-8a1ff7238ace",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-d889-77c8-9e64-575e06d7f43b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-d889-77c8-9e64-575e06d7f43b",
        "storage_key": "property/6767906449166904/019d08af-d889-77c8-9e64-575e06d7f43b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8594-76dc-85a5-91465483d7f8",
        "storage_key": "property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b89c7dec-d947-43ea-b570-1ff0054e22d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-d8c0-7168-8038-af82ccfc964f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-d8c0-7168-8038-af82ccfc964f",
        "storage_key": "property/6767906449166904/019d08af-d8c0-7168-8038-af82ccfc964f.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8594-76dc-85a5-91465483d7f8",
        "storage_key": "property/6767906449166904/019d08af-8594-76dc-85a5-91465483d7f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_69efac9c-c9b9-401d-9143-4a18eb4c5527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-e078-729c-85ed-ee688ff9d796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e078-729c-85ed-ee688ff9d796",
        "storage_key": "property/6767906449166904/019d08af-e078-729c-85ed-ee688ff9d796.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8bfd-768b-9a59-d4ed21b0310c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8bfd-768b-9a59-d4ed21b0310c",
        "storage_key": "property/6767906449166904/019d08af-8bfd-768b-9a59-d4ed21b0310c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_793a765d-57a2-4197-b2ef-cd63fd88a3a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-df4e-7409-a13a-c01c77020304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-df4e-7409-a13a-c01c77020304",
        "storage_key": "property/6767906449166904/019d08af-df4e-7409-a13a-c01c77020304.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f5-766a-9725-22bc27f69750",
        "storage_key": "property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ca4c0c40-3898-4375-b8aa-97f8dab3a77c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-e189-7117-a296-232a9929a79f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e189-7117-a296-232a9929a79f",
        "storage_key": "property/6767906449166904/019d08af-e189-7117-a296-232a9929a79f.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f5-766a-9725-22bc27f69750",
        "storage_key": "property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1e533b22-6e9c-4562-8835-5785a5faa6b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-e0d5-72bd-9144-056fe543cf15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e0d5-72bd-9144-056fe543cf15",
        "storage_key": "property/6767906449166904/019d08af-e0d5-72bd-9144-056fe543cf15.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-86f5-766a-9725-22bc27f69750",
        "storage_key": "property/6767906449166904/019d08af-86f5-766a-9725-22bc27f69750.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5fe56a3f-34ac-492b-b841-3f360d619610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-e82f-77ec-a59d-07bb799b91d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-e82f-77ec-a59d-07bb799b91d6",
        "storage_key": "property/6767906449166904/019d08af-e82f-77ec-a59d-07bb799b91d6.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8bfd-768b-9a59-d4ed21b0310c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8bfd-768b-9a59-d4ed21b0310c",
        "storage_key": "property/6767906449166904/019d08af-8bfd-768b-9a59-d4ed21b0310c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4525698e-4083-47a9-9aec-0ef017c23e9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-72b8-7408-9a50-44ade9a47696.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-72b8-7408-9a50-44ade9a47696",
        "storage_key": "property/6767906449166904/019d08af-72b8-7408-9a50-44ade9a47696.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8d8d-7158-838f-29f02da9e584.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8d8d-7158-838f-29f02da9e584",
        "storage_key": "property/6767906449166904/019d08af-8d8d-7158-838f-29f02da9e584.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_683a9129-fe7a-497e-8a8a-e89fa7d04c53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-7a2f-736b-9ba6-d6203dd6c19f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-7a2f-736b-9ba6-d6203dd6c19f",
        "storage_key": "property/6767906449166904/019d08af-7a2f-736b-9ba6-d6203dd6c19f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8d8d-7158-838f-29f02da9e584.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8d8d-7158-838f-29f02da9e584",
        "storage_key": "property/6767906449166904/019d08af-8d8d-7158-838f-29f02da9e584.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e8e02f63-a614-4bb4-801c-bb7fc73c3c1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-45ad-757f-8dbe-03a909b8e86f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-45ad-757f-8dbe-03a909b8e86f",
        "storage_key": "property/6767906449166904/019d08af-45ad-757f-8dbe-03a909b8e86f.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_5968d5ca-c540-4b76-bee4-448076e15d39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-ecd3-7630-a510-ceab793db5ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-ecd3-7630-a510-ceab793db5ea",
        "storage_key": "property/6767906449166904/019d08af-ecd3-7630-a510-ceab793db5ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_fbed347e-69ab-42d0-a54e-780ae44fe6ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-eccf-72bd-b581-b37c54a4fa84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-eccf-72bd-b581-b37c54a4fa84",
        "storage_key": "property/6767906449166904/019d08af-eccf-72bd-b581-b37c54a4fa84.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-90b5-77e6-a061-5664bc400b91",
        "storage_key": "property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_83b9a1bb-205c-46f6-a3cb-79bbe8364c3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-eccf-72bd-b581-b9d9b1f75448.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-eccf-72bd-b581-b9d9b1f75448",
        "storage_key": "property/6767906449166904/019d08af-eccf-72bd-b581-b9d9b1f75448.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-90b5-77e6-a061-5664bc400b91",
        "storage_key": "property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2e5b473e-4838-4159-84ff-9bbeec779f1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Roseville Utility Exploration Center",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_long_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-ef32-751f-a1b4-88e555aa7fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-ef32-751f-a1b4-88e555aa7fdc",
        "storage_key": "property/6767906449166904/019d08af-ef32-751f-a1b4-88e555aa7fdc.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.roseville.ca.us/explore",
      "poi_directions_map_url": "https://maps.google.com/?cid=910903833852852384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-utility-exploration-center",
      "poi_latitude": "38.7674387",
      "poi_longitude": "-121.332085",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-746-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-90b5-77e6-a061-5664bc400b91",
        "storage_key": "property/6767906449166904/019d08af-90b5-77e6-a061-5664bc400b91.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8ooIkAhm4ARoDhX8TUupAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_afa186a1-4f13-4cd8-be30-50127d6237d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-f23f-7794-9a6f-7176308510ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f23f-7794-9a6f-7176308510ab",
        "storage_key": "property/6767906449166904/019d08af-f23f-7794-9a6f-7176308510ab.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b5d6fbc8-b176-4208-a70e-4c10a4c70758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "336 N Sunrise Ave, Roseville, CA 95661, USA",
      "poi_short_description": "Chain fitness center with cardio and strength machines, a pool, a sauna, and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-f2ca-77f3-b69f-a9311c16aeab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f2ca-77f3-b69f-a9311c16aeab",
        "storage_key": "property/6767906449166904/019d08af-f2ca-77f3-b69f-a9311c16aeab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/roseville-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5665805128877314491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7539734",
      "poi_longitude": "-121.261129",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-772-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUHYiIkfm4ARu5FR-b77oE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2eec9a98-49d2-4078-b788-3510bd2db0d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-f423-737c-88a3-fad5688477b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-f423-737c-88a3-fad5688477b8",
        "storage_key": "property/6767906449166904/019d08af-f423-737c-88a3-fad5688477b8.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_939679de-4742-499e-aa0a-8fa9ff24ea92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6831 Lonetree Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain gym with cardio and strength-training equipment, massage chairs, tanning beds, and showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-54f2-764b-ab9c-dd4dfea2a6e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-54f2-764b-ab9c-dd4dfea2a6e3",
        "storage_key": "property/6767906449166904/019d08af-54f2-764b-ab9c-dd4dfea2a6e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/rocklin-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10254324074506971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7976671",
      "poi_longitude": "-121.2899537",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-755-6015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4x-sEZojm4ARfGq5gGqtTo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_51e84539-3d6a-457e-ad4a-14a6657ba209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "VCA Loomis Basin Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Sierra College Blvd, Loomis, CA 95650, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-fa46-74eb-ae6d-731c49b3750b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fa46-74eb-ae6d-731c49b3750b",
        "storage_key": "property/6767906449166904/019d08af-fa46-74eb-ae6d-731c49b3750b.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/loomis-basin?utm_source=maps&utm_medium=organic&utm_campaign=AU_935",
      "poi_directions_map_url": "https://maps.google.com/?cid=3050520726901175039&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-loomis-basin-veterinary-clinic",
      "poi_latitude": "38.81533",
      "poi_longitude": "-121.207103",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-652-5816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-uKVdAem4AR_zLpUnCgVSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_86bb4eca-d38a-401f-9ebc-d34de8b4ffda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-fa8d-72dd-b9b5-47d49e282a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fa8d-72dd-b9b5-47d49e282a8c",
        "storage_key": "property/6767906449166904/019d08af-fa8d-72dd-b9b5-47d49e282a8c.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_c64fb6cb-5628-418c-a292-500c92050c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the gym is a decent size and the front desk staff is usually friendly. They also like the welcoming atmosphere and the willingness of members to share advice. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-fb41-71ef-bf06-dc22a64f600f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fb41-71ef-bf06-dc22a64f600f",
        "storage_key": "property/6767906449166904/019d08af-fb41-71ef-bf06-dc22a64f600f.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_28929176-fdea-4138-9d23-20c5512745c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large variety of equipment, a pool, a sauna, and a steam room. They also highlight the friendly staff, the beautiful views, and the good vibe.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-fc54-776a-b569-579367e852f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-fc54-776a-b569-579367e852f9",
        "storage_key": "property/6767906449166904/019d08af-fc54-776a-b569-579367e852f9.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3723d06f-8fe7-49bf-8bd6-1a7fc029820d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-4aa1-734d-97c1-76c51b9be0e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-4aa1-734d-97c1-76c51b9be0e7",
        "storage_key": "property/6767906449166904/019d08af-4aa1-734d-97c1-76c51b9be0e7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-9327-756e-9834-22ed2f152644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-9327-756e-9834-22ed2f152644",
        "storage_key": "property/6767906449166904/019d08af-9327-756e-9834-22ed2f152644.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c491c440-6d0c-4d5c-8d2e-435c10e49e58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-018a-727e-b9c6-b87ccbb82441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-018a-727e-b9c6-b87ccbb82441",
        "storage_key": "property/6767906449166904/019d08b0-018a-727e-b9c6-b87ccbb82441.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-9327-756e-9834-22ed2f152644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-9327-756e-9834-22ed2f152644",
        "storage_key": "property/6767906449166904/019d08af-9327-756e-9834-22ed2f152644.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e51b30d8-887f-4116-9376-7f1a96ae684e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-0239-76e3-bfc3-2e6bc7fccb77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0239-76e3-bfc3-2e6bc7fccb77",
        "storage_key": "property/6767906449166904/019d08b0-0239-76e3-bfc3-2e6bc7fccb77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-95d4-716a-ac3e-f126b9df8d78",
        "storage_key": "property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0ed55a90-7176-47dd-a1ef-da6a98de372c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-5ca0-71fe-b1ea-a6e63baddd92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08af-5ca0-71fe-b1ea-a6e63baddd92",
        "storage_key": "property/6767906449166904/019d08af-5ca0-71fe-b1ea-a6e63baddd92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-95d4-716a-ac3e-f126b9df8d78",
        "storage_key": "property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_50df910b-bfa0-4ffd-a2c0-0802ed6c531d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-04d9-77d2-a773-d9f472c5c032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-04d9-77d2-a773-d9f472c5c032",
        "storage_key": "property/6767906449166904/019d08b0-04d9-77d2-a773-d9f472c5c032.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-95d4-716a-ac3e-f126b9df8d78",
        "storage_key": "property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_42d463b9-67cc-4249-8286-3f3c0dff188c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Rusch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7801 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Outdoor skating & biking spot with concrete surface, numerous unique features & lighting at night.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including pickleball courts, tennis courts, a swimming pool, playgrounds, and walking trails. They also highlight the clean and well-maintained grounds, and the spacious open areas perfect for picnics and recreational activities.\n\nOther reviews mention there can be homeless people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-0721-7528-9e73-8c9bb081a93a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0721-7528-9e73-8c9bb081a93a",
        "storage_key": "property/6767906449166904/019d08b0-0721-7528-9e73-8c9bb081a93a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sunriseparks.com/rusch-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352438582190195855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rusch-community-park",
      "poi_latitude": "38.70897069999999",
      "poi_longitude": "-121.2912232",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-95d4-716a-ac3e-f126b9df8d78",
        "storage_key": "property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCebD9pDfmoARj8SW8AUd5AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f9b10c0c-49e5-416f-8fcf-74e0618e0572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Mahany Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1545 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_long_description": "Expansive park with sports & aquatic centers, athletic fields & a universally accessible playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-08e0-7708-bc52-a88f50cabbc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-08e0-7708-bc52-a88f50cabbc6",
        "storage_key": "property/6767906449166904/019d08b0-08e0-7708-bc52-a88f50cabbc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7614086073060341684&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mahany-park",
      "poi_latitude": "38.7674183",
      "poi_longitude": "-121.3341323",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-95d4-716a-ac3e-f126b9df8d78",
        "storage_key": "property/6767906449166904/019d08af-95d4-716a-ac3e-f126b9df8d78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp32Y_0Ahm4ARtLcCOvGqqmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01537484-99ac-49f9-b889-450800831d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-0a0b-73a9-b19b-9e51272e61fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0a0b-73a9-b19b-9e51272e61fe",
        "storage_key": "property/6767906449166904/019d08b0-0a0b-73a9-b19b-9e51272e61fe.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6a0c8133-361c-4029-babe-a76d67f946af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-0ce9-729a-a9a5-7567f9af90fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-0ce9-729a-a9a5-7567f9af90fd",
        "storage_key": "property/6767906449166904/019d08b0-0ce9-729a-a9a5-7567f9af90fd.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cfa98240-e425-4a83-aae0-1b5ef45a6f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_29bfe5bd-a4b1-487e-b4c8-de8ee38c3239",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e491c945-978e-41fc-942e-87f49f4539a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "poi_name": "WSI Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3750 Atherton Rd, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08b0-1028-76d0-8026-1eca6669df6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-1028-76d0-8026-1eca6669df6f",
        "storage_key": "property/6767906449166904/019d08b0-1028-76d0-8026-1eca6669df6f.webp",
        "width": 574,
        "height": 574
      },
      "poi_business_url": "http://www.williams-sonomainc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14374488400562628873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wsi-corporate-office",
      "poi_latitude": "38.8164424",
      "poi_longitude": "-121.2953052",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 415-421-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08af-8595-76f9-9011-683eb40c8098",
        "storage_key": "property/6767906449166904/019d08af-8595-76f9-9011-683eb40c8098.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDfctaUcim4ARCSmCfwpxfMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a3983346cb44c2f4870353a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_61fe5507a550146a0888616c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_45b17efaf839352c1fe18e75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_f6c5e039fe07fff23191389d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_d5d3df71f8f041792a3ddaab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_0a6b74c62652bc54f96ed378",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_7aa1f813-0786-4c73-9ddb-439c2fe2ff72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "rating": "5.0",
      "name": "Jeff",
      "text": "I just moved in my apartment and I love it here it's quiet,clean and the staff is friendly and helpful",
      "date": "2025-01-31",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_504ffe0c-47d2-4db8-b2a2-79176d62ae23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d3132-a489-7649-bddc-6d47d3d37089.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3132-a489-7649-bddc-6d47d3d37089",
        "storage_key": "property/6767906449166904/019d3132-a489-7649-bddc-6d47d3d37089.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rocklin Gold Apartments - Rec. Room & Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NVzx6uHkYyx"
    },
    {
      "id": "custom_f79f8590-cc4c-4e59-9e62-2bcb05b21fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d3133-a285-774d-9e29-b5c0eac155f9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3133-a285-774d-9e29-b5c0eac155f9",
        "storage_key": "property/6767906449166904/019d3133-a285-774d-9e29-b5c0eac155f9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rocklin Gold Apartments - Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GRLzHxxuss5"
    },
    {
      "id": "custom_36db989b-af07-4e6e-a4de-d437eeb537fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d3133-bfaa-7409-8c7d-d8932fdbd771.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3133-bfaa-7409-8c7d-d8932fdbd771",
        "storage_key": "property/6767906449166904/019d3133-bfaa-7409-8c7d-d8932fdbd771.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rocklin Gold Apartments - 2 Bedroom 2 Bath 1074 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=axV1MLKLyrE"
    },
    {
      "id": "custom_d1fc394c-32e2-442b-9c96-03ac1f762cd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166904/019d3133-db3f-70c4-ac48-41d23759d966.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d3133-db3f-70c4-ac48-41d23759d966",
        "storage_key": "property/6767906449166904/019d3133-db3f-70c4-ac48-41d23759d966.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Rocklin Gold Apartments - 1 Bedroom 1 Bath 784 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GnuaPheARFL"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1b8-4ca9-761c-8691-1351896fc478",
      "lead_source": "LANDING_PAGE",
      "name": "Rocklin Gold Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-rocklin-ca",
      "search_query": "pet friendly apartments Rocklin CA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Rocklin, CA",
      "h2_subtitle": "Discover pet-friendly living at Rocklin Gold. Enjoy a welcoming community for you and your furry friends in Rocklin, CA.",
      "page_copy": "Rocklin Gold offers stunning pet friendly apartments in Rocklin, CA. Our welcoming community understands that pets are family too, which is why we’ve created an environment where they can thrive alongside you. With amenities such as a fitness center and a sparkling swimming pool, you'll have everything you need to keep both you and your pet active and happy. \n\nLocated on Sunset Boulevard, our community provides reserved parking and easy access to local parks and pet services in Placer County. Residents enjoy the serene atmosphere and quality living spaces designed with their lifestyle in mind. Choose Rocklin Gold for a pet welcoming, comfortable living experience in Rocklin, CA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Rocklin, CA",
      "seo_description": "Find your ideal pet friendly apartment at Rocklin Gold in Rocklin, CA. Perfect for you and your furry family members.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-with-reserved-parking-rocklin",
      "search_query": "apartments with reserved parking Rocklin",
      "category": "Amenity",
      "h1_title": "Apartments with Reserved Parking in Rocklin",
      "h2_subtitle": "Rocklin Gold offers apartments with the convenience of reserved parking. Your ideal home in Rocklin awaits.",
      "page_copy": "At Rocklin Gold, finding apartments with reserved parking in Rocklin is easier than ever. Our community is designed to offer the utmost convenience, starting with dedicated parking spaces so you can always count on having a spot waiting for you after a long day. \n\nLocated on Sunset Boulevard in beautiful Placer County, Rocklin Gold combines the charm of Rocklin living with the practicality of modern amenities. Enjoy easy access to a fitness center and a relaxing swimming pool, perfectly complementing the convenience of reserved parking. Experience a harmonious balance of comfort and accessibility at Rocklin Gold.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Reserved Parking in Rocklin",
      "seo_description": "Discover Rocklin Gold, featuring apartments with reserved parking for your convenience in Rocklin, CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-placer-county",
      "search_query": "fitness center apartments Placer County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Placer County",
      "h2_subtitle": "Upgrade your lifestyle at Rocklin Gold, offering apartments with a state-of-the-art fitness center in Placer County.",
      "page_copy": "Rocklin Gold features premium fitness center apartments in Placer County, perfect for those who value health and convenience in daily living. Our on-site fitness center is equipped with everything you need to maintain your active lifestyle without ever leaving home. Whether you're into cardio or strength training, we've got you covered.\n\nNestled on Sunset Boulevard in Rocklin, our apartments come with additional perks such as a refreshing swimming pool and easy accessibility to local amenities. With the fitness center just steps away, achieving your wellness goals has never been more convenient. Discover a community that supports your healthy lifestyle at Rocklin Gold.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Placer County",
      "seo_description": "Find your home at Rocklin Gold with a state-of-the-art fitness center, ideally located in Placer County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "rocklin-apartments-with-a-pool",
      "search_query": "Rocklin apartments with a pool",
      "category": "Amenity",
      "h1_title": "Rocklin Apartments with a Pool",
      "h2_subtitle": "Enjoy Rocklin living with a refreshing pool at Rocklin Gold. Dive into comfort and convenience today.",
      "page_copy": "Embrace the ultimate relaxation at Rocklin Gold, where our Rocklin apartments with a pool provide a perfect escape from the everyday hustle. Our shimmering swimming pool is the centerpiece of our community, offering residents a great place to unwind and socialize with neighbors.\n\nSituated on Sunset Boulevard in the heart of Rocklin, our community combines comfort, style, and convenience. In addition to the beautiful pool, residents enjoy access to other top-notch amenities like our fitness center and reserved parking. Experience a unique lifestyle in Rocklin that centers around leisure and convenience at Rocklin Gold.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rocklin Apartments with a Pool",
      "seo_description": "Discover Rocklin Gold, where you can enjoy apartments with a refreshing pool in Rocklin. Dive into a lifestyle of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "95677-pet-friendly-rentals",
      "search_query": "95677 pet friendly rentals",
      "category": "Amenity",
      "h1_title": "95677 Pet Friendly Rentals",
      "h2_subtitle": "Find a welcoming home for you and your pets at Rocklin Gold, located in the 95677 area.",
      "page_copy": "Rocklin Gold invites you and your furry friends to explore our pet friendly rentals in the 95677 area. Nestled in the vibrant city of Rocklin, our community is designed with amenities that cater to both you and your pets.\n\nOur welcoming environment on Sunset Boulevard provides easy access to paths and nearby parks, perfect for pet walks. Along with being pet-friendly, Rocklin Gold offers great features such as a fitness center, swimming pool, and reserved parking, creating a comfortable living experience for all family members, furry ones included. Discover the perfect pet-friendly home at Rocklin Gold.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "95677 Pet Friendly Rentals in Rocklin",
      "seo_description": "Explore Rocklin Gold's pet-friendly rentals in the 95677 area, where pets are part of the family.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-rocklin-ca",
      "search_query": "one bedroom apartments Rocklin CA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Rocklin, CA",
      "h2_subtitle": "Explore our one bedroom apartments at Rocklin Gold, ideally located in Rocklin, CA.",
      "page_copy": "Discover the perfect blend of comfort and style with our one bedroom apartments in Rocklin, CA, at Rocklin Gold. Situated on Sunset Boulevard, our community offers an ideal setting for singles or couples seeking a cozy living space.\n\nEach apartment is thoughtfully designed to maximize space and convenience, featuring modern amenities and access to our fitness center and sparkling swimming pool. Reserved parking ensures ease of access, while pet-friendly policies welcome furry companions. Make Rocklin Gold your home and enjoy everything Rocklin, CA, has to offer from a prime location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Rocklin, CA",
      "seo_description": "Find your ideal one bedroom apartment at Rocklin Gold, located perfectly in Rocklin, CA, with top amenities and pet-friendly options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-95677",
      "search_query": "two bedroom apartments near 95677",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 95677",
      "h2_subtitle": "Spacious and modern two bedroom apartments are available near 95677 at Rocklin Gold.",
      "page_copy": "Experience the comfort of spacious living in our two bedroom apartments near 95677 at Rocklin Gold. Located in the lively community of Rocklin, these apartments offer ample living space, perfect for families, roommates, or those needing a home office.\n\nOur apartments come with convenient access to great amenities, including a pristine swimming pool, well-equipped fitness center, and reserved parking. Situated on Sunset Boulevard, you'll enjoy proximity to local shops, dining, and entertainment, making Rocklin Gold a fantastic choice for anyone seeking convenience and comfort in the 95677 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 95677",
      "seo_description": "Discover spacious two bedroom apartments near 95677 at Rocklin Gold. Enjoy great living with modern amenities in a prime Rocklin location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-near-sierra-college-rocklin",
      "search_query": "apartments near Sierra College Rocklin",
      "category": "School",
      "h1_title": "Apartments Near Sierra College in Rocklin",
      "h2_subtitle": "Live close to Sierra College with convenient apartment options at Rocklin Gold in Rocklin, CA.",
      "page_copy": "Rocklin Gold offers an ideal location for those seeking apartments near Sierra College in Rocklin. Perfect for students, faculty, and staff, our community provides easy access to the campus while offering comfortable and modern living solutions.\n\nLocated on Sunset Boulevard, our apartments come with a variety of amenities such as a swimming pool, fitness center, and reserved parking. In addition, the pet-friendly policy ensures that your furry friends feel right at home. Enjoy a short commute and ample recreational options, making Rocklin Gold the perfect base for academic and personal pursuits near Sierra College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sierra College, Rocklin",
      "seo_description": "Find convenient and comfortable apartments near Sierra College at Rocklin Gold. Enjoy modern living and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-close-to-jessup-university-95677",
      "search_query": "apartments close to Jessup University 95677",
      "category": "School",
      "h1_title": "Apartments Close to Jessup University 95677",
      "h2_subtitle": "Find ideal living at Rocklin Gold, perfectly situated near Jessup University in the 95677 area.",
      "page_copy": "Discover the convenience of living close to Jessup University in the 95677 area with the thoughtfully designed apartments at Rocklin Gold. Our community offers students and faculty an ideal blend of proximity and comfort.\n\nLocated on Sunset Boulevard, our apartments boast modern amenities including a fitness center and a refreshing swimming pool. With reserved parking and pet-friendly policies, Rocklin Gold provides a welcoming environment that caters to diverse lifestyles, all within an easy reach of Jessup University. Enjoy a vibrant community setting perfect for balancing study and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Jessup University 95677",
      "seo_description": "Explore apartments at Rocklin Gold near Jessup University in 95677. Perfect mix of proximity, comfort, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "rocklin-apartments-near-sutter-roseville-medical-center",
      "search_query": "Rocklin apartments near Sutter Roseville Medical Center",
      "category": "Hospital",
      "h1_title": "Rocklin Apartments Near Sutter Roseville",
      "h2_subtitle": "Discover comfortable living in Rocklin with easy access to Sutter Roseville Medical Center.",
      "page_copy": "For those seeking Rocklin apartments near Sutter Roseville Medical Center, Rocklin Gold provides a perfect blend of convenience and comfort. Located a short drive away, our community is ideal for healthcare professionals and patients seeking accommodation near the facility.\n\nRocklin Gold offers modern amenities including a swimming pool, fitness center, and ample reserved parking, all in a pet-friendly environment. Situated on Sunset Boulevard in Rocklin, our apartments promise a convenient lifestyle with easy access to medical services and local amenities. Experience comfortable living with all the essentials within reach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rocklin Apartments Near Sutter Roseville",
      "seo_description": "Find Rocklin apartments near Sutter Roseville Medical Center at Rocklin Gold. Enjoy convenient living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-close-to-kaiser-permanente-roseville-building-c",
      "search_query": "apartments close to Kaiser Permanente Roseville Building C in Placer County",
      "category": "Hospital",
      "h1_title": "Apartments Near Kaiser Permanente Roseville",
      "h2_subtitle": "Experience vibrant living at Rocklin Gold, located close to Kaiser Permanente Roseville Building C in Placer County.",
      "page_copy": "Rocklin Gold offers prime apartments close to Kaiser Permanente Roseville Building C in Placer County, providing healthcare professionals and visitors with a convenient place to call home. Our location on Sunset Boulevard ensures easy access to medical facilities, enhancing your work-life balance.\n\nOur community features desirable amenities, including a fitness center and a sparkling swimming pool. Enjoy the convenience of reserved parking and pet-friendly units in a welcoming neighborhood. At Rocklin Gold, you'll find the perfect mix of comfort and accessibility near Kaiser Permanente.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kaiser Permanente Roseville",
      "seo_description": "Explore Rocklin Gold's apartments near Kaiser Permanente Roseville Building C. Enjoy top amenities in Placer County's prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-near-maidu-regional-park-rocklin-ca",
      "search_query": "apartments near Maidu Regional Park Rocklin CA",
      "category": "Park",
      "h1_title": "Apartments Near Maidu Regional Park",
      "h2_subtitle": "Enjoy nearby nature and activities at Maidu Regional Park with Rocklin Gold's ideal location in Rocklin, CA.",
      "page_copy": "Rocklin Gold offers premium living just a short distance from Maidu Regional Park, Rocklin, CA. Our apartments provide the perfect home for those who love outdoor activities and the peace of nature.\n\nSituated on Sunset Boulevard, Rocklin Gold boasts modern amenities like a swimming pool, a fully equipped fitness center, and reserved parking. Our pet-friendly policy ensures your furry friends can join the adventure too. Experience a balance of indoor comfort and outdoor exploration with Maidu Regional Park within easy reach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maidu Regional Park Rocklin",
      "seo_description": "Live near Maidu Regional Park at Rocklin Gold. Enjoy fantastic amenities and explore Rocklin, CA's beautiful outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-close-to-johnson-springview-park-placer-county",
      "search_query": "apartments close to Johnson-Springview Park Placer County",
      "category": "Park",
      "h1_title": "Apartments Near Johnson-Springview Park",
      "h2_subtitle": "Discover easy access to Johnson-Springview Park while enjoying the comforts of Rocklin Gold in Placer County.",
      "page_copy": "Located near the heart of Placer County, Rocklin Gold offers comfortable apartments close to Johnson-Springview Park. Enjoy the convenience of having beautiful trails, sports courts, and picnic areas just minutes from your home.\n\nOur community at Rocklin Gold features an array of lifestyle-enhancing amenities such as a sparkling swimming pool and a spacious fitness center. With pet-friendly policies and reserved parking, we provide a welcoming environment for everyone. Relish the perfect blend of nature and comfort with seamless access to Johnson-Springview Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson-Springview Park",
      "seo_description": "Live near Johnson-Springview Park at Rocklin Gold. Enjoy great amenities in a prime Placer County location close to nature and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "rocklin-ca-apartments-near-harry-crabb-park",
      "search_query": "Rocklin CA apartments near Harry Crabb Park",
      "category": "Park",
      "h1_title": "Rocklin Apartments Near Harry Crabb Park",
      "h2_subtitle": "Enjoy the convenience of living near Harry Crabb Park with Rocklin Gold's ideal location in Rocklin, CA.",
      "page_copy": "Discover the ideal living experience at Rocklin Gold, where our Rocklin, CA apartments are conveniently near Harry Crabb Park. Perfect for outdoor enthusiasts and families, this proximity provides easy access to extensive lawns, playgrounds, and sports fields.\n\nRocklin Gold offers a selection of modern amenities, including a fully-equipped fitness center, a relaxing swimming pool, and reserved parking options. Our pet-friendly community welcomes furry companions, ensuring everyone feels at home. Live close to the vibrant park life and enjoy all the comforts of Rocklin Gold.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harry Crabb Park Rocklin",
      "seo_description": "Find your home near Harry Crabb Park at Rocklin Gold. Enjoy top amenities and lush park proximity in Rocklin, CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "apartments-near-rusch-community-park-95677",
      "search_query": "apartments near Rusch Community Park 95677",
      "category": "Park",
      "h1_title": "Apartments Near Rusch Community Park",
      "h2_subtitle": "Experience convenience and relaxation near Rusch Community Park with Rocklin Gold's prime location.",
      "page_copy": "At Rocklin Gold, enjoy beautifully appointed apartments near Rusch Community Park, located in the 95677 area. Our location offers quick access to the park's recreational facilities like the swimming pool, sports fields, and serene picnic spots.\n\nOur community features include a fitness center and a shimmering swimming pool, providing perfect spaces for relaxation and entertainment. With pet-friendly policies and reserved parking, Rocklin Gold perfectly balances leisure, comfort, and convenience, right near beautiful Rusch Community Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rusch Community Park 95677",
      "seo_description": "Live near Rusch Community Park in Rocklin Gold. Enjoy top amenities and park activities in the 95677 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166904",
      "source": "generator",
      "page_item_url": "placer-county-apartments-close-to-mahany-park",
      "search_query": "Placer County apartments close to Mahany Park",
      "category": "Park",
      "h1_title": "Placer Apartments Near Mahany Park",
      "h2_subtitle": "Enjoy Placer County living close to Mahany Park, with top-notch amenities at Rocklin Gold.",
      "page_copy": "Find your perfect home at Rocklin Gold, offering Placer County apartments close to Mahany Park. This strategic location ensures residents have swift access to the park's expansive green spaces, sports facilities, and community events.\n\nOur community is designed with your needs in mind, featuring a state-of-the-art fitness center and a sparkling swimming pool. With convenient reserved parking and a pet-friendly atmosphere, Rocklin Gold provides a welcoming environment just a stone's throw from Mahany Park. Experience the best of both comfort and outdoor adventure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Placer Apartments Near Mahany Park",
      "seo_description": "Discover Rocklin Gold, offering Placer County living near Mahany Park with top amenities and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5961"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372414492"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-NLHWZXC8"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-621-2095 "
    }
  ],
  "custom_qb_id": "5961",
  "custom_repli_id": "18372414492",
  "custom_google_gtm_id": "\tGTM-NLHWZXC8",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-621-2095 "
};

export const generatedAt = '2026-10-02T21:24:54.805Z';
